import React from "react";
import "./App.css";
import BzrpLanding from "./components/BzrpLanding/BzrpLanding";
import HowToContest from "./components/BzrpLanding/HowToContest";
import ContestSessions from "./components/BzrpLanding/ContestSesions";
import RemixSection from "./components/BzrpLanding/RemixSection";
import SagasSection from "./components/BzrpLanding/SagasSection";
import DiscordSection from "./components/BzrpLanding/DiscordSection";
import ChooseSection from "./components/BzrpLanding/ChooseSection";
import Footer from "./components/footer";

function App() {
  return (
    <div className="App">
      <head>
        <style>
          @import
          url('https://fonts.googleapis.com/css2?family=Dosis&display=swap');
          @import
          url('https://fonts.googleapis.com/css2?family=Dosis&family=IBM+Plex+Sans&display=swap');
          @import url("https://use.typekit.net/mgo4mbw.css");
        </style>
        <title>Bizarrap Contest</title>
      </head>
      <BzrpLanding />
      <HowToContest />
      <ContestSessions />
      <RemixSection />
      <SagasSection />
      <ChooseSection />
      <DiscordSection />
      <Footer />
    </div>
  );
}

export default App;
